/**
=========================================================

* Tazi Rides Ltd has developed this dashboard based on a further configured version of the original template.
* Website: https://www.tazirides.co.uk
* All rights reserved.

=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

* This template has been built upon, with additional code and configuration by Tazi Rides Ltd.
*/

import { ReactNode } from 'react'

// @mui material components
import Grid from '@mui/material/Grid'

// Material Dashboard 2 PRO React TS components

import laurelLogo from 'assets/images/laurel-logo.png'
import MDBox from 'components/MDBox'
import { useMaterialUIController } from 'context/materialUI'
import PageLayout from 'modules/LayoutContainers/PageLayout'

// Declaring props types for BasicLayout
interface Props {
	children: ReactNode
}

function BasicLayout({ children }: Props): JSX.Element {
	const [controller] = useMaterialUIController()
	const { orgAssets } = controller
	return (
		<PageLayout>
			<MDBox position="absolute" width="100%" minHeight="100vh" />
			<MDBox
				display={'flex'}
				flexDirection={'row'}
				justifyContent={'center'}
				pt={'5vh'}
				alignItems={'center'}
				gap={2}
			>
				<MDBox
					component="img"
					src={orgAssets?.logo?.light || laurelLogo}
					alt="Brand"
					width="15vw"
				/>
			</MDBox>
			<MDBox px={1} width="100%" height="70vh" mx="auto">
				<Grid container spacing={1} justifyContent="center" alignItems="center" height="100%">
					<Grid item xs={11} sm={9} md={5} lg={4} xl={3}>
						{children}
					</Grid>
				</Grid>
			</MDBox>
		</PageLayout>
	)
}

export default BasicLayout
